export const MAX_WIDTH = 16;
export const DEFAULT_WIDTH = 16;

export const MAX_ROWS = 2;
export const MAX_TILES_PER_ROW = 2;

export const MAX_ALLOWED_TILE_IMAGES = 1;
